module.exports = __webpack_public_path__ + "img/source_sw-item8.7c4c902d.png";